import { useRef, useState, useEffect } from 'react';

const useBarcodeScanner = () => {
  const [barcode, setBarcode] = useState<string | null>(null);
  const inputRef = useRef<{ data: string, timer: NodeJS.Timeout | null }>({ data: '', timer: null });

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const { key } = e;
      if (key === 'Enter') {
        if (inputRef.current.data.length > 10) {
          setBarcode(inputRef.current.data);
          inputRef.current.data = '';
        }
      } else {
        clearTimeout(inputRef.current.timer as NodeJS.Timeout);
        inputRef.current.data += key;
        inputRef.current.timer = setTimeout(() => {
          inputRef.current.data = '';
        }, 25);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return barcode;
};

export default useBarcodeScanner;
